module.exports = __webpack_public_path__ + "img/close.1e70cad1.svg";